var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("DropdownFilter", {
    attrs: {
      value: _vm.value,
      options: _vm.statusOptions,
      customMultiStyleParent: _vm.getcontainerStyle,
      multiple: false,
      placeholder: "Select status",
      withoutLoading: "",
    },
    on: { input: _vm.handleInput },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }